import { Hike } from './Hike';
import { ResourceLinkedEvent } from './ResourceEvents';

export type ResourceResultsObject = Record<string, ErrorResourceResult | OtherResourceResult>;

export enum ResourceResultStatus {
  ERROR = 'error',
  WARNING = 'warning',
  SKIP = 'skip',
  SUCCESS = 'success',
  BUSY = 'busy',
}

export type ErrorResourceResultStatus = ResourceResultStatus.ERROR | ResourceResultStatus.WARNING;
export interface ErrorResourceResult extends ResourceResult {
  status: ErrorResourceResultStatus;
  msg: string;
  error?: string;
}

export interface OtherResourceResult extends ResourceResult {
  id?: string;
  status: ResourceResultStatus;
}

export type ResourceResult = {
  msg?: string;
};

export type HikeCreateEvent = {
  label?: string;
  hitches: string[];
  hitch?: string;
  resource?: string;
  info?: (string | undefined)[];
};

export type HikeEventStatus = 'new' | 'busy' | 'success' | 'failed';

export type TriggerCause = 'webhook' | 'preview' | 'manual' | 'machine';

export type Cause = {
  type: TriggerCause;
  event: string;
};
export interface TriggerCreateEvent {
  hike: Hike;
  triggerHitch: string;
  status: HikeEventStatus;
  cause: Cause;
  resource: ResourceLinkedEvent;
  linkedResource?: ResourceLinkedEvent[];
}

export interface TriggerEvent extends TriggerCreateEvent {
  id: string;
  createdAt: Date;
  updatedAt: Date;
  result?: ResourceResultsObject;
}
export interface HikeEvent extends HikeCreateEvent {
  id: string;
  createdAt: Date;
  finishedAt?: Date;
  resourceId?: string;
  url?: string;
  status: HikeEventStatus;
}

export const hikeEventsLabels: Record<string, string> = {
  SUBSCRIPTION: 'SUBSCRIPTION',
  REMOVE_SUBSCRIPTION: 'REMOVE_SUBSCRIPTION',
  CREATE_HIKE: 'CREATE_HIKE',
  CREATE_RESOURCE: 'CREATE_RESOURCE',
  ACTIVATE_HIKE: 'ACTIVATE_HIKE',
  UPDATE_HIKE: 'UPDATE_HIKE',
  REMOVE_HIKE: 'REMOVE_HIKE',
  CHANGE_PREFERENCES: 'CHANGE_PREFERENCES',
};

export const hikeEventsTranslations: Record<string, string> = {
  SUBSCRIPTION: 'Subscribe to apps',
  REMOVE_SUBSCRIPTION: 'Remove subscription to apps',
  CREATE_HIKE: 'Create a new Hitch',
  UPDATE_HIKE: 'Hitch has been updated',
  CREATE_RESOURCE: 'Create new resource',
  ACTIVATE_HIKE: 'Hitch activated',
  REMOVE_HIKE: 'Hitch removed',
  CHANGE_PREFERENCES: 'Preferences changed',
};
